module.exports = __webpack_public_path__ + "static/media/long.c26aa35d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catbot/long.png
// module id = 148
// module chunks = 0